__webpack_require__.p = "https://fakundo.github.io/tarkov-raid-items/";